import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export var ALIGNMENT = {
  AUTO: 'auto',
  START: 'start',
  CENTER: 'center',
  END: 'end'
};
export var DIRECTION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
export var SCROLL_CHANGE_REASON = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};
export var scrollProp = _defineProperty(_defineProperty({}, DIRECTION.VERTICAL, 'scrollTop'), DIRECTION.HORIZONTAL, 'scrollLeft');
export var sizeProp = _defineProperty(_defineProperty({}, DIRECTION.VERTICAL, 'height'), DIRECTION.HORIZONTAL, 'width');
export var positionProp = _defineProperty(_defineProperty({}, DIRECTION.VERTICAL, 'top'), DIRECTION.HORIZONTAL, 'left');
export var marginProp = _defineProperty(_defineProperty({}, DIRECTION.VERTICAL, 'marginTop'), DIRECTION.HORIZONTAL, 'marginLeft');
export var oppositeMarginProp = _defineProperty(_defineProperty({}, DIRECTION.VERTICAL, 'marginBottom'), DIRECTION.HORIZONTAL, 'marginRight');